import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
	session:null,
	temp:null,
	departName: '', 
	departId:'',  
	departUid:'',
	userName: '', //当前用户姓名
	companyUid:'',
	companyName:'',
	companyId:'',
	userUid: '',     //用户36位id
	userLogo: '',  //用户头像
	avatar:'',
	// themeBG:"rgba(68,210,255,0.2)",
	themeBG:"#fff",
	themeColor:"#F08B00",
	loading:false,
	totalUsers:[], //公司员工集合
	orgDatas:[], //部门数集合
	editDepart:Object,
	orgSelected:Object,//选中的部门
	orgUserDatas:[],
	positionList:[], //岗位集合
	selectProjectNode:{},
	memberSearchText:'',
	selectProjectObj:{}
};

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters
});


// WEBPACK FOOTER //
// ./src/store/index.js